<template>
    <v-container fluid fill-height>
        <v-layout justify-center align-center>
            <h1>This is the help page</h1>
        </v-layout>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Help',
  created () {
    this.setTitle({ title: 'Help' })
  },
  methods: {
    ...mapActions(
      'application', {
        setTitle: 'setTitle'
      }
    )
  }
}
</script>
